import { Box, BoxProps, ColorOptions } from '@jfs/ui-new'
import { FC } from 'react'

interface SeparatorProps {
  width?: string | number
  height?: string | number
  border?: ColorOptions
  hide?: boolean
}

const Separator: FC<SeparatorProps> = ({ width, border, height, hide = false }: SeparatorProps) => {
  if (hide) {
    return null
  }
  const getStyles = (): BoxProps => {
    return {
      backgroundColor: border,
      width,
      height,
    }
  }
  const separatorStyle = getStyles()
  return <Box {...separatorStyle} />
}

export { Separator }
